<template>
    <UserActivityTile @click="tileClicked()" :userActivity="userActivity">


        <template v-slot:title>From {{ userActivity.body.referralsCount }} Friends.</template>
        <template v-slot:subtitle>Referral Earning</template>


        <template v-slot:append-item-right>

            <UserActivityCoinChip>
                {{ $abbreviateNumber(userActivity.body.coinsAmount) }}
            </UserActivityCoinChip>

        </template>

    </UserActivityTile>
</template>



<script lang="ts" setup>

import { useRouter } from 'vue-router';
import { PropType } from 'vue';
import { IReferralEarningUserActivity } from '@/interfaces/UserActivity/IReferralEarningUserActivity';

import UserActivityTile from './UserActivityTile.vue';
import UserActivityCoinChip from '@/components/UserActivity/UserActivityTileElements/UserActivityCoinChip.vue';

const props = defineProps({
    userActivity: {
        type: Object as PropType<IReferralEarningUserActivity>,
        required: true,
    },
});

const router = useRouter();

const tileClicked = () => {
    router.push('/referrals');
}

</script>
